module.exports = __webpack_public_path__ + "img/alarm-clock.955f5db7.svg";